<template>
  <div class="d-inline-block align-middle">
    <div>
      <button @click.prevent="modalTriggerValue = true" class="btn btn-primary">Remove From Panel</button>
    </div>

    <modal v-show="modalTriggerValue" modalclass="no-footer" @close="modalTriggerCloseModal()" clickoutside="true">
      <div slot="header" class="d-flex justify-content-between full-width">
        <i class="close-icon cursor-pointer" @click="modalTriggerCloseModal()"></i>
      </div>
      <div class="content" slot="body">
        <div class="email-faculty">
          Are you sure you want to remove this entry from the panel?  It will remove all judgements associated with the entry.
          <div class="d-flex justify-content-center mt-3 mb-3">
            <button type="submit" @click="removeFromPanel()">Yes, Remove Entry From Panel</button>
          </div>
        </div>
      </div>
    </modal>
  </div>

</template>

<script>
  import modal from './Modal.vue';

  export default {
    props: ['action_url'],
    components: {modal},
    data() {
      return {
        modalTriggerValue: false
      }
    },
    methods: {
      modalTriggerCloseModal: function() {
        this.modalTriggerValue = false;
      },
      removeFromPanel: function() {
        axios.post(this.action_url).then(res => {
          location.reload()
        });
      }
    }
  };
</script>